//*******************************************************
// simple modal
//*******************************************************
import { v4 as uuidv4 } from 'uuid';
export class Modal {
   constructor(options) {
      // fail early
      if (!options) options = {};
      if (options && options.target && !document.querySelector(options.target)) {
         console.log('NO MODAL TARGET DEFINED');
         return false;
      }
      // settings
      //--------------------------------------------------------
      const defaultOptions = {
         uuid: `modal-${uuidv4()}`,
      };
      this.settings = {
         ...defaultOptions,
         target: options.target ? options.target : null,
         mode: options.mode ? options.mode : null,
      };
      // init
      //--------------------------------------------------------
      this.init();
   }
   open() {
      console.log('open', this);
      this.settings.container.classList.add('modal--opened');
      //if no async loading dont show loader
      if (!this.settings.target) this.settings.container.classList.add('modal--loading');
   }
   close() {
      console.log('close', this);
      return new Promise((resolve, reject) => {
         this.settings.container.classList.remove('modal--opened');
         resolve('closed');
      });
   }
   destroy() {
      console.log(this);
      this.settings.container.remove();
   }
   isOpened() {
      return this.settings.container.classList.contains('modal--opened');
   }
   loadContent(content) {
      if (!content) {
         console.log('Modal.loadContent() didnt receive any content');
         return false;
      }
      const container = document.querySelector(`.modal__content--${this.settings.uuid}`);
      if (container) {
         container.innerHTML = content;
         this.settings.container.classList.remove('modal--loading');
      } else {
         console.log('Container not found');
      }

      // attach events in case there is a close button in the new content
      this.attachEvents();
   }
   clearContent() {
      // const content = document.querySelector(`.modal__content--modal-${this.settings.uuid}`);
      const content = this.settings.container.querySelector('.modal__content');
      if (content) {
         content.innerHTML = '';
      } else {
         console.warn('.modal__content not found');
      }
   }
   changeMode(mode) {
      this.settings.container.classList.add(mode);
   }
   init() {
      const target = document.querySelector(this.settings.target);
      const html = target ? target.innerHTML : '';
      const modalMarkup = document.createElement('div');
      modalMarkup.classList.add('modal');
      if (this.settings.mode) modalMarkup.classList.add(this.settings.mode);
      modalMarkup.setAttribute('id', this.settings.uuid);
      modalMarkup.innerHTML = `
          <div class="modal__inner">
             <div class="modal__content modal__content--${this.settings.uuid}">
                ${html}
             </div>
          </div>
          <button class="modal__close modal__close-btn"></button>
       `;
      document.querySelector('body').appendChild(modalMarkup);
      this.settings.container = document.querySelector(`#${this.settings.uuid}`);
      if (target) target.remove();

      //attach close events
      this.attachEvents();
   }

   attachEvents() {
      const closeBtns = this.settings.container.querySelectorAll('.modal__close');
      if (closeBtns) {
         console.log('closeBtns: ', closeBtns);
         closeBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
               this.close();
            });
         });
      }

      // close the modal and clear the event listeners
      //--------------------------------------------------------
      const handleOutsideClick = (e) => {
         if (this.isOpened()) {
            const target = e.target;
            console.log(target);
            if (
               target.classList.contains('modal__close') ||
               (!target.classList.contains('modal__inner') && target.classList.contains('modal'))
               // target !== this.settings.modalWrapper && !this.settings.modalWrapper.contains(e.target)
            ) {
               this.close();
               this.clearContent();
               document.removeEventListener('click', handleOutsideClick);
            }
         }
      };
      document.addEventListener('click', handleOutsideClick);
   }
}
